import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ColectiveAgreement } from "../_types/colective-agreement";

@Injectable({
  providedIn: 'root',
})
export class ColectiveAgreementsService extends Service<ColectiveAgreement> {
  public override type = 'colectiveAgreements';
  public override url = 'common/colectiveAgreements';
}
